module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": "",
      "height": "calc(100vh - 470px)"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Kontoname")]), _vm._v(" "), _c('th', [_vm._v("IBAN")]), _vm._v(" "), _c('th', [_vm._v("BIC")]), _vm._v(" "), _c('th', [_vm._v("Bank")]), _vm._v(" "), _c('th', [_vm._v("Sepa-Einzug möglich")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kassen), function(item, itemObjKey) {
    return (item !== 'kassen') ? _c('tr', {
      key: itemObjKey
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.kontoname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.IBAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.BIC))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.bank))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sepa))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.neueKasse = item) && (_vm.istNeu = false)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)]) : _vm._e()
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "disabled": !_vm.istNeu,
      "hint": "Der Name kann später nicht mehr geändert werden!",
      "outlined": "",
      "label": "Name"
    },
    model: {
      value: (_vm.neueKasse.name),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "name", $$v)
      },
      expression: "neueKasse.name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Kontoname"
    },
    model: {
      value: (_vm.neueKasse.kontoname),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "kontoname", $$v)
      },
      expression: "neueKasse.kontoname"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Absender für Mails"
    },
    model: {
      value: (_vm.neueKasse.absender),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "absender", $$v)
      },
      expression: "neueKasse.absender"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-select', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "items": _vm.templates,
      "label": "Mailtemplate"
    },
    model: {
      value: (_vm.neueKasse.template),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "template", $$v)
      },
      expression: "neueKasse.template"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "IBAN",
      "hint": "ohne Leerzeichen"
    },
    model: {
      value: (_vm.neueKasse.IBAN),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "IBAN", $$v)
      },
      expression: "neueKasse.IBAN"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "BIC"
    },
    model: {
      value: (_vm.neueKasse.BIC),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "BIC", $$v)
      },
      expression: "neueKasse.BIC"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Bank"
    },
    model: {
      value: (_vm.neueKasse.bank),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "bank", $$v)
      },
      expression: "neueKasse.bank"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "dense": "",
      "outlined": "",
      "label": "Gläubiger ID"
    },
    model: {
      value: (_vm.neueKasse.glaubigerID),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "glaubigerID", $$v)
      },
      expression: "neueKasse.glaubigerID"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-checkbox', {
    attrs: {
      "on-icon": "check_box",
      "off-icon": "check_box_outline_blank",
      "label": "Sepa-Einzug möglich"
    },
    model: {
      value: (_vm.neueKasse.sepa),
      callback: function($$v) {
        _vm.$set(_vm.neueKasse, "sepa", $$v)
      },
      expression: "neueKasse.sepa"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-alert', {
    attrs: {
      "border": "bottom",
      "color": "accent",
      "colored-border": "",
      "type": "warning",
      "icon": "warning"
    }
  }, [_vm._v("\n          Einmal erstellte Kassen können nicht mehr umbenannt oder gelöscht werden!\n        ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        (_vm.neueKasse = []) && (_vm.istNeu = true)
      }
    }
  }, [_c('v-icon', [_vm._v("settings_backup_restore")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "icon": "",
      "dark": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.addKasse()
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce49256"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/Kassen.vue
// module id = 739
// module chunks = 15